// extracted by mini-css-extract-plugin
module.exports = {"sc__header":"_3eGqw2G5EAmfGeKZfpPn5C"};